<template>
    <img :src="$global.httpUrl+'/sywl/user/getVerifiCode?v='+date" @click="refresh" >
</template>

<script>
  export default {
    data() {
      return {
        date: ''
      }
    },
    mounted() {
      this.refresh();
    },
    methods: {
      refresh() {
        this.date = new Date().getTime();
      }
    }
  }
</script>

<style scoped>
  img {
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/img-code.vue